import { useEffect, useState } from 'react';
import { NoResultImage } from '@images';

import { EmptyScreenProps } from '@types';

import Button from '../button/Button';

const EmptyScreen = ({
  buttonId,
  title = 'Results not found',
  description = 'We couldn’t find what you’re looking for',
  className = '',
  handleClick,
  emptyScreenImage: EmptyScreenImage = NoResultImage,
  buttonLabel,
  leftIconName,
  butttonStyle = 'my-8',
  buttonLabelStyle,
  leftIconStroke,
  variant,
  isButtonDisabled = false,
  titleStyle,
  descriptionStyle,
  enableFadeIn = false
}: EmptyScreenProps) => {
  const buttonVariant = variant || 'secondary';
  const [isFadedIn, setIsFadedIn] = useState(!enableFadeIn);

  useEffect(() => {
    if (!enableFadeIn) {
      setIsFadedIn(true);
      return undefined;
    }
    setIsFadedIn(false);
    const frameId = requestAnimationFrame(() => {
      setIsFadedIn(true);
    });
    return () => cancelAnimationFrame(frameId);
  }, [enableFadeIn]);

  const fadeClass = enableFadeIn
    ? `transition-opacity duration-[900ms] ease-out ${
        isFadedIn ? 'opacity-100' : 'opacity-0'
      }`
    : '';

  return (
    <div
      className={`flex size-full flex-col items-center justify-center ${className}`}
    >
      <div className={fadeClass}>
        <EmptyScreenImage />
      </div>
      {title && (
        <div
          className={`${titleStyle} mt-8 text-2xl font-bold ${fadeClass} ${
            enableFadeIn ? 'delay-150' : ''
          }`}
        >
          {title}
        </div>
      )}
      {!!description && (
        <div
          className={`${descriptionStyle} mt-2 text-sm font-normal text-grey ${fadeClass} ${
            enableFadeIn ? 'delay-300' : ''
          }`}
        >
          {description}
        </div>
      )}
      {buttonLabel && (
        <Button
          id={buttonId}
          variant={buttonVariant}
          label={buttonLabel}
          size="large"
          handleClick={handleClick}
          className={butttonStyle}
          leftIconName={leftIconName}
          labelStyle={buttonLabelStyle}
          leftIconStroke={leftIconStroke}
          disabled={isButtonDisabled}
        />
      )}
    </div>
  );
};

export default EmptyScreen;
